export default {
  asteroid: ["#000000", "#000000", "#787878", "#404040", "#707070", "#969696"],
  bleak: ["#192529", "#080a0c", "#1d2e35", "#4d5d66", "#e6e6e6", "#ffffff"],
  desertisland: ["#107aa8", "#ffffff", "#aca077", "#d9d79b", "#688532", "#598d25"],
  extraplanar: ["#ffffff", "#c2c2c2", "#000000", "#000000", "#7f0606", "#ff0000"],
  longago: ["#445674", "#2c3344", "#968a69", "#e8dab5", "#d6caa8", "#cec4a1"],
  parchment: ["#cdbc90", "#a0926d", "#fde8b0", "#dcc995", "#c8b37c", "#ffeab2"],
  phosphor: ["#002903", "#009919", "#00ff2a", "#01c60e", "#00bd26", "#00ff11"],
  plain: ["#6792a8", "#e0f5ff", "#564f3e", "#81805a", "#989b7d", "#b1b091"],
  shrouded: ["#1f0420", "#603a6e", "#442b54", "#1d101e", "#070209", "#000000"],
  talkie: ["#696969", "#2e2e2e", "#808080", "#c4c4c4", "#9e9e9e", "#8c8c8c"],
  verdant: ["#107aa8", "#70dbff", "#0c5a26", "#08811c", "#83d864", "#89dd78"],
  volcanic: ["#903504", "#c66001", "#121212", "#50423f", "#858080", "#ababab"],
};
